(function(angular){
    'use strict';

    angular.module('onvio.setup.client.notifications').controller('onvio.setup.client.notifications.ClientNotificationsController', clientNotifications);
    clientNotifications.$inject = ['$rootScope', '$q', '$translate', 'bmLanguageManager', 'messageFactory'];

    function clientNotifications($rootScope, $q, $translate, bmLanguageManager, messageFactory){
        /*jshint validthis:true */
        var vm = this;

        // initialize tab headings before translations loaded
        vm.notificationTabHeading = '';
        vm.wordingTabHeading = '';
        vm.stylingTabHeading = '';

        vm.styleTabSelect = styleTabSelect;
        vm.styleTabDeselect = styleTabDeselect;
        vm.styleLanguageTabDeselect = styleLanguageTabDeselect;
        vm.wordingTabSelect = wordingTabSelect;
        vm.wordingTabDeselect = wordingTabDeselect;
        vm.wordingLanguageTabSelect = wordingLanguageTabSelect;

        initView();

        // no longer necessary as code was changed to reload the app on language change
        //$rootScope.$on('bmLanguageChangeSuccess', initView);

        //////////

        function initView(){
            $q.all(loadTranslations(), loadLanguages(), loadCategories());
        }

        function loadTranslations(){
            var promises = [
                $translate('Onvio.Setup.Client.Notifications.NotificationsTitle'),
                $translate('Onvio.Setup.Client.Notifications.WordingTitle'),
                $translate('Onvio.Setup.Client.Notifications.StylingTitle')
            ];

            return $q.all(promises).then(function(values){
                vm.notificationTabHeading = values[0];
                vm.wordingTabHeading = values[1];
                vm.stylingTabHeading = values[2];
            });
        }

        function loadLanguages(){
            return bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                languages[0].selected = true;
                vm.languages = languages;
            });
        }

        function loadCategories(){
            return messageFactory.getCategoriesWithTypes('external').then(function(categories){
                vm.categoryList = categories;
            }, function(){
                // TODO: HANDLE ERROR DISPLAY
                vm.categoryList = [];
            });
        }

        function styleTabSelect(){
            // removed unsaved notificaiton when tab is selected
            vm.hasUnsavedStyleChanges = false;
        }

        function styleTabDeselect(){
            var hasDirty = false;

            for(var i = 0; i < vm.languages.length; i++){
                var language = vm.languages[i];

                // save off dirty state of currently selected category/type
                if(language.selected){
                    language.setDirty();
                }

                if(language.hasUnsavedChanges){
                    hasDirty = true;
                }
            }

            vm.hasUnsavedStyleChanges = hasDirty;
        }

        function styleLanguageTabDeselect(selectedLanguage){
            // toggle the form state for indicator disply
            selectedLanguage.setDirty();
        }

        function wordingTabSelect(){
            // removed unsaved notificaiton when tab is selected
            vm.hasUnsavedWordingChanges = false;
        }

        function wordingTabDeselect(){
            var hasDirty = false;

            for(var i = 0; i < vm.languages.length; i++){
                var language = vm.languages[i];

                // save off dirty state of currently selected category/type
                if(language.selected){
                    language.setTabDirtyDisplay();
                }

                if(language.hasUnsavedTypes){
                    hasDirty = true;
                }
            }

            vm.hasUnsavedWordingChanges = hasDirty;
        }

        function wordingLanguageTabSelect(selectedLanguage){
            // set the selected language for display of wording form
            angular.forEach(vm.languages, function(language){
                language.selected = selectedLanguage.code === language.code;
            });
        }
    }
})(window.angular);
